import cookies from 'js-cookie';
import { getCurrentInstance } from 'vue';
import { compareVersion, getOneLinkUrl, getOneLinkUrlNew, getTargetUrlFromWebOrDesktop, getTgOneLinkUrl, getTgTargetUrl } from '@/common/utils';
import { callApp } from '@/common/call-app';
import { isTMA, useTelegram } from '~/hooks/useTelegram';

// export const launchApp = (params: { callAppPath?: string }) => {
//   const callAppPath = params?.callAppPath || 'home'

//   const targetUrl = getTargetUrlFromWebOrDesktop()

//   const oneLinkUrl = getOneLinkUrl(targetUrl, callAppPath)

//   callApp({
//     path: `${callAppPath}?target_url=${targetUrl}`,
//     onelink: oneLinkUrl,
//   });
// };

export const launchApp = (params?: { callAppPath?: string; query?: Record<string, string>; targetUrlExtraParams?: Record<string, any> }) => {
    if (isTMA()) {
        const opened = launchAppInTgByOnelink(params);
        if (opened) {
            return;
        }
    }
    const callAppPath = params?.callAppPath || 'home';
    const targetUrlExtraParams = params?.targetUrlExtraParams;

    const targetUrl = getTargetUrlFromWebOrDesktop(targetUrlExtraParams);

    const oneLinkUrl = getOneLinkUrl(targetUrl, callAppPath);

    let queryStr = '';

    if (params?.query) {
        // queryStr = `&${new URLSearchParams(params.query)}`
        queryStr = `&${Object.entries(params.query)
            .map(([key, val]) => `${key}=${val || ''}`)
            .join('&')}`;
        // queryStr = `& ${ new URLSearchParams(params.query) } `
    }
    if (targetUrlExtraParams) {
        window.location.href = getOneLinkUrlNew(targetUrl, callAppPath);
    } else {
        callApp({
            path: `${callAppPath}?target_url=${targetUrl}${queryStr}`,
            onelink: oneLinkUrl,
        });
    }
};

export const launchAppInTgByOnelink = (params?: {
    callAppPath?: string;
    query?: Record<string, string>;
    targetUrlExtraParams?: Record<string, any>;
}) => {
    const callAppPath = params?.callAppPath || 'home';
    const targetUrlExtraParams = params?.targetUrlExtraParams;

    const targetUrl = getTgTargetUrl(targetUrlExtraParams);
    const oneLinkUrl = getTgOneLinkUrl(targetUrl, callAppPath);

    const decodedOneLink = decodeURIComponent(oneLinkUrl); // tg内部会encode导致无法正常解析onelink而无法拉端
    if (decodedOneLink) {
        const { openLink } = useTelegram();
        openLink(decodedOneLink);
        return true;
    }
    return false;
};

// 商业化设备指纹
export const initDeviceFingerprint = () => {
    const script = document.createElement('script');
    const executeInnerHtml = `!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";var o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var o,r=0,i=t.length;r<i;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t,n){var o,i=e.createElement("script");i.type="text/javascript",i.async=!0,i.src=t,n&&(i.onerror=function(){r(e,n)});var a=e.getElementsByTagName("script")[0];null===(o=a.parentNode)||void 0===o||o.insertBefore(i,a)};!function(e,t,n){e.KwaiAnalyticsObject=n;var i=e[n]=e[n]||[];i.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];var a=function(e,t){e[t]=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];var i=o([t],n,!0);e.push(i)}};i.methods.forEach((function(e){a(i,e)})),i.instance=function(e){var t,n=(null===(t=i._i)||void 0===t?void 0:t[e])||[];return i.methods.forEach((function(e){a(n,e)})),n},i.load=function(e,o){var a="https://s1.kwai.net/kos/s101/nlav11187/pixel/custom/core-noery.js";i._i=i._i||{},i._i[e]=[],i._i[e]._u=a,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=o||{};var c="?sdkid=".concat(e,"&lib=").concat(n);r(t,a+c,"https://s16-11187.ap4r.com/kos/s101/nlav11187/pixel/custom/core-noery.js"+c)}}(window,document,"kwaiq")}])}));kwaiq.load('244796266603650');kwaiq.page();`;
    script.innerHTML = executeInnerHtml;
    document.body.appendChild(script);
};

// 下发tab动态化参数给到app，app动态化配置魔方
export const injectTabStrategyToAppIfNeeded = () => {
    const { proxy }: any = getCurrentInstance() || {};
    const startupData: any = proxy?.$store?.state?.startup;

    if (!proxy?.$isAppEnvironment || !startupData?.dynamicTabsConfig) {
        return;
    }

    const appVersion = cookies?.get('appver');
    if (!appVersion || compareVersion(appVersion, '1.7.2') < 0) {
        return;
    }

    try {
        window?.$yoda?.invoke?.('component.setWebConfig', {
            key: 'dynamicTabsConfig',
            value: JSON.stringify(startupData?.dynamicTabsConfig),
        });
    } catch (error) {
        console.log('Error injecting dynamicTabsConfig:', error);
    }
};
